import { Form, Input } from "antd";
import { type ReactElement } from "react";
const { TextArea } = Input;

interface CpInstructionProps {
  loading: boolean;
  formData: any;
  pIndex: number;
  item?: any;
  handleChangeFormData: (data: any) => void;
}

export const CpInstruction = ({
  loading,
  formData,
  pIndex,
  item = {},
  handleChangeFormData,
}: CpInstructionProps): ReactElement => {
  const handleChange = (value: string): any => {
    formData[pIndex].instructions = value;
    handleChangeFormData([...formData]);
  };
  return (
    <div className="instructions-container">
      <Form className="min-max-rates-inputs">
        <Form.Item label={"Instructions"} className="input-rate-label" required>
          <TextArea
            disabled={loading}
            value={item.instructions}
            onChange={(e: any) => {
              handleChange(e.target.value);
            }}
            className="input-number"
            size="large"
          />
        </Form.Item>
      </Form>
    </div>
  );
};
